import React from 'react';
import styles from './ChangeImpactReviewList.module.css';

const ChangeImpactReviewList = ({ title, entities }) => {
  return (
    <div>
      <h3 className="flex text-muted m-b-12">{title}</h3>
      {entities.length ? (
        <ul className={styles.impactedList}>
          {entities.map((item) => (
            <li key={item.id} className={item?.archived ? 'text-muted' : ''}>
              {item.name}
              <p className="text-muted">{item?.note}</p>
            </li>
          ))}
        </ul>
      ) : (
        <div>—</div>
      )}
    </div>
  );
};

export default ChangeImpactReviewList;
